import { APICore } from '../helpers/api/apiCore';
import { findObject } from '../utils/AllFunction';
import { apiReturnCallBack } from './ApiConfig';
import apiContainer from './apiContainer';
const api = new APICore();

const Landmark = apiContainer.Landmark
//GET--->
// Corrected getLandmark function
export async function getLandmarkApi(request) {
    let findObj = findObject(request);
    try {
        return api.get(`${Landmark}`, findObj);
    } catch (error) {
        console.error('Fetch error:', error);
        throw error;
    }
}
//CREATE---->
export async function createLandmark(request) {
    try {
        return api.create(`${Landmark}`, request);
    } catch (error) {
        console.error('Fetch error:', error);
        throw error;
    }
}
//UPDATE---->
export async function updateLandmark(request, LandmarkId) {
    try {
        return api.update(`${Landmark}/${LandmarkId}`, request);
    } catch (error) {
        console.error('Fetch error:', error);
        throw error;
    }
}
//DELETE---->
export async function deleteLandmark(LandmarkId) {
    try {
        return api.delete(`${Landmark}/${LandmarkId}`);
    } catch (error) {
        console.error('Fetch error:', error);
        throw error;
    }
}



